export default [
  'clickDownload',
  'clickToAddDoc',
  'clickView',
  'documentGenerated'
]
